import { render, staticRenderFns } from "./ClickableInput.vue?vue&type=template&id=b988fb8e&scoped=true"
import script from "./ClickableInput.vue?vue&type=script&lang=js"
export * from "./ClickableInput.vue?vue&type=script&lang=js"
import style0 from "./ClickableInput.vue?vue&type=style&index=0&id=b988fb8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b988fb8e",
  null
  
)

export default component.exports